export default {
  consultPage: {
    pageTitle: '咨询中心',
    railTitle: '咨询类型',
    railDesc: '请留下您的联系信息和感兴趣的量表，我们会根据咨询内容安排对应人员跟进',
    types: [
      { label: '产品咨询', value: 'pre_sale' },
      { label: '项目合作', value: 'service_support' }
    ],
    name: '姓名',
    email: '邮箱',
    company: '单位',
    phone: '手机',
    product: '感兴趣的量表',
    address: '地址',
    message: '信息',
    namePlaceholder: '请输入姓名',
    emailPlaceholder: '请输入邮箱',
    companyPlaceholder: '请输入单位名称',
    phonePlaceholder: '请输入手机号',
    productPlaceholder: '请选择具体量表',
    addressPlaceholder: '请输入所在地区或详细地址',
    messagePlaceholder: '请输入你想咨询的内容',
    privacyPrefix: '我已阅读并同意',
    privacyPolicy: '《个人信息保护政策》',
    privacySuffix: '，允许华晟育林使用以上信息进行咨询跟进',
    submit: '提交咨询',
    submitting: '提交中...',
    success: '咨询已提交',
    invalidEmail: '请输入正确的邮箱',
    required: '请完整填写咨询信息'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/locales/zh/consult.js